import {
  createAchAgreementRequest,
  createHaaAgreementRequest,
  createIraAgreementRequest,
  createMetalStreamAgreementRequest,
  downloadAchAgreementRequest,
  downloadHaaAgreementRequest,
  downloadIraAgreementRequest,
  downloadMetalStreamAgreementRequest,
  downloadPDFAchAgreementRequest,
  downloadPDFHaaAgreementRequest,
  downloadPDFIraAgreementRequest,
  downloadPDFMetalStreamAgreementRequest,
} from '../../request/agreementRequest';
import { AGREEMENT_TYPES } from '../constants';

export const downloadAgreementRequestHelper = (type) => {
  switch (type) {
    case AGREEMENT_TYPES.HAA:
      return downloadHaaAgreementRequest;

    case AGREEMENT_TYPES.ACH:
      return downloadAchAgreementRequest;

    case AGREEMENT_TYPES.IRA:
      return downloadIraAgreementRequest;

    case AGREEMENT_TYPES.METAL_STREAM:
      return downloadMetalStreamAgreementRequest;

    default:
      break;
  }
};

export const createAgreementRequestHelper = (type) => {
  switch (type) {
    case AGREEMENT_TYPES.HAA:
      return createHaaAgreementRequest;

    case AGREEMENT_TYPES.ACH:
      return createAchAgreementRequest;

    case AGREEMENT_TYPES.IRA:
      return createIraAgreementRequest;

    case AGREEMENT_TYPES.METAL_STREAM:
      return createMetalStreamAgreementRequest;

    default:
      break;
  }
};

export const downloadPDFAgreementRequestHelper = (type) => {
  switch (type) {
    case AGREEMENT_TYPES.HAA:
      return downloadPDFHaaAgreementRequest;

    case AGREEMENT_TYPES.ACH:
      return downloadPDFAchAgreementRequest;

    case AGREEMENT_TYPES.IRA:
      return downloadPDFIraAgreementRequest;

    case AGREEMENT_TYPES.METAL_STREAM:
      return downloadPDFMetalStreamAgreementRequest;

    default:
      break;
  }
};
